// extracted by mini-css-extract-plugin
module.exports = {"input-mode-select-area":"_3c6ef300a5--input-mode-select-area--SKq1q","alert-area":"_3c6ef300a5--alert-area--lKnbS"};